/*jslint node: true*/
"use strict";

var ko = require("pli/knockout");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ExpandText knockout binding
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

///<summary>
///     Creates a binding that displays what looks like a textbox,
///     and upon clicking expands into a textarea
///</summary>
///<param name='settings' type='object'>
///     <param name='value' type='observable'>
///         The observable to bind to the textarea value
///     </param>
///     <param name='expanded' type='observable'>
///         An observable that is notified of the state of the expandText. if it is focused/expanded or not
///         programtically setting it to true will also trigger the element to focus
///     </param>
///     <param name='minHeight' type='number=25'>
///         A number that specifies the height that the textarea collapses to
///     </param>
///     <param name='maxHeight' type='number=75'>
///         A number that specifies the height that the textarea expands to
///     </param>
///</param>
///--------------------------------------------------
ko.bindingHandlers.expandText = {
    init: function (element, valueAccessor, allBindings) {
        var val, height, settings = valueAccessor(),
            focus = ko.observable(false),
            minHeight = 25,
            maxHeight = 75,
            expanded = ko.observable();

        //validate input
        if (typeof settings !== "object") { throw new Error("An object is expected for this binding"); }
        if (!ko.isObservable(settings.value)) { throw new Error("The value was expected to be an observable"); }

        //assign values
        val = settings.value;
        minHeight = !isNaN(parseInt(settings.minHeight, 10)) ? parseInt(settings.minHeight, 10) : minHeight;
        maxHeight = !isNaN(parseInt(settings.maxHeight, 10)) ? parseInt(settings.maxHeight, 10) : maxHeight;
        expanded = ko.isObservable(settings.expanded) ? settings.expanded : expanded;

        //compute if the textarea is focused and/or has values
        ko.computed(function () {
            var v = val();
            expanded((v !== null && v !== undefined && v !== '') || focus());
        });

        //ensure there is focus, if there is values or if programitcally expanded
        expanded.subscribe(function (v) {
            focus(v);
        });

        //compute which height to use
        height = ko.computed(function () {
            return (expanded() ? maxHeight : minHeight) + "px";
        });

        //attach necessary bindings to the node
        ko.applyBindingsToNode(element, {
            value: val,
            hasFocus: focus,
            style: { height: height },
            valueUpdate: allBindings.has('valueUpdate') ? allBindings.get('valueUpdate') : undefined,
            enable: allBindings.has('enable') ? allBindings.get('enable') : true
        });
    }
};


//-------------------------------------------
module.exports = ko;



//////////////////
// WEBPACK FOOTER
// ./app/ko-expandtext/expandText.js
// module id = 548
// module chunks = 49